import CloseIcon from '@mui/icons-material/Close';
import { Stack, useTheme } from '@mui/material';
import { motion } from 'motion/react';
import { FunctionComponent } from 'react';
import { gamePlayStore, useGameplaySelector } from '../../store/GameplayStore';
import { adaptTransition } from '../../util/Animation';
import { muiStyleSheet } from '../../util/Styles';
import { STRIKE_ANIM_DURATION } from './StrikeOverlay';

export const StrikeIndicator: FunctionComponent = () => {
	const theme = useTheme();
	const { strikes, maxStrikes } = useGameplaySelector(gamePlayStore.selectors.strikes);

	return <Stack spacing={1}>
		{Array.from({ length: maxStrikes }).map((_, index) => {
			const isActive = index < strikes;

			/** Container */
			return <motion.div key={index}
				initial={false}
				animate={{
					scale: isActive ? [1, 1.4, 1] : 1,
					opacity: isActive ? 1 : 0.3,
					rotate: isActive ? [0, -10, 10, 0] : 0,
					backgroundColor: isActive ? theme.palette.game.strikeActive : theme.palette.game.strikeInactive,
					boxShadow: isActive
						? '0 6px 16px rgba(0,0,0,0.6)'
						: '0 4px 8px rgba(0,0,0,0.3)',
				}}
				transition={adaptTransition({
					// Wait until the StrikeOverlay anim is mostly complete
					delay: STRIKE_ANIM_DURATION.asSeconds() * 0.75,
					duration: 0.5,
					ease: 'easeOut',
				})}
				style={styles.container(theme)}
			>
				{isActive &&
					<motion.div
						initial={{ scale: 0, rotate: -180 }}
						animate={{ scale: 1, rotate: 0 }}
						transition={adaptTransition({
							delay: STRIKE_ANIM_DURATION.asSeconds(),
							duration: 0.4,
							ease: 'backOut'
						})}
						style={{ display: 'flex', alignItems: 'center' }}
					>
						<CloseIcon sx={{
							fontSize: '3rem',
							color: theme.palette.game.white,
							fontWeight: 'bold',
						}} />
					</motion.div>}
			</motion.div>;
		})}
	</Stack>;
};

const styles = muiStyleSheet({
	/** Circular background with border */
	container: theme => ({
		width: '60px',
		height: '60px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: '50%',
		border: `4px solid ${theme.palette.game.white}`,
	}),
});